import React, {useCallback, useMemo, useState} from 'react';
import {useFaqPageContext} from '@assets/contexts/faqPageContext';
import {Popper, Typography, Paper, ClickAwayListener} from '@mui/material';
import {faqSearchByWordHandler} from '@assets/helpers/searchHelper';
import removeImagesAndKeepText from '@assets/helpers/removeImagesAndKeepText';
import SearchFaqIcon from '../Icon/SearchFaqIcon';

const FaqPageCardThemeSearch = ({isPreview}) => {
  const {i18n, questions, handleSelectCategory, handleSelectQuestion} = useFaqPageContext();
  const [open, setOpen] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState(null);

  const [keySearch, setKeySearch] = useState('');
  const handleSearch = useCallback(value => setKeySearch(value), []);
  const searchHandler = faqSearchByWordHandler();

  const searchQuestions = useMemo(() => {
    const newQuestion = questions.map(el => ({
      ...el,
      textAnswer: removeImagesAndKeepText(el.answer)
    }));

    if (!keySearch) return newQuestion;
    return searchHandler(keySearch, newQuestion);
  }, [keySearch, questions]);

  const handleInputFocus = event => {
    setPopoverAnchor(event.currentTarget);
    setOpen(true);
  };

  const handleClosePopover = () => {
    setOpen(false);
    setPopoverAnchor(null);
  };

  const handleItemClick = item => {
    handleSelectCategory(item.categoryId);
    handleSelectQuestion(item);
    handleClosePopover();
  };

  return (
    <ClickAwayListener onClickAway={handleClosePopover}>
      <div
        className="Avada-Faq_Search"
        style={{
          position: 'relative',
          backgroundColor: '#ffffff',
          height: isPreview ? '48px' : '60px',
          minHeight: isPreview ? '48px' : '60px'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '10px'
          }}
        >
          <SearchFaqIcon color={'#8A8A8A'} />
        </div>
        <input
          value={keySearch}
          name="faq-search"
          className="Avada-Faq_Search-Box"
          placeholder={i18n('FAQ page search placeholder')}
          onChange={e => handleSearch(e.target.value)}
          onFocus={handleInputFocus}
        />
        <Popper
          open={open}
          anchorEl={popoverAnchor}
          placement="bottom"
          style={{width: '100%', paddingRight: '18px', zIndex: 10}}
          disablePortal={true}
          modifiers={[
            {name: 'flip', enabled: false},
            {name: 'offset', options: {offset: [0, 200]}}
          ]}
        >
          <Paper className="Avada-Faq_Search-Popper">
            {searchQuestions?.length ? (
              searchQuestions.map(el => (
                <div
                  key={el.questionId}
                  onClick={() => handleItemClick(el)}
                  className="Avada-Faq_Search-Container-Box"
                >
                  <Typography
                    className="Avada-Faq_Articles-Question"
                    style={{fontSize: '16px', color: '#303030', fontWeight: 650}}
                  >
                    {el.question}
                  </Typography>
                  <Typography className="Avada-Faq_Articles-Answer" style={{marginTop: '8px'}}>
                    {el.textAnswer}
                  </Typography>
                </div>
              ))
            ) : (
              <div
                style={{
                  width: '50vw',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Typography className="Avada-Faq_Not-Found">
                  {i18n('"No matching article found" message')}
                </Typography>
              </div>
            )}
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default FaqPageCardThemeSearch;
